var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column-search"},[_c('search',{attrs:{"keyWords":_vm.searchKeyWord},on:{"goSearch":_vm.getSearchList}}),_vm._v(" "),_c('row-item-list',{attrs:{"list":_vm.searchList}}),_vm._v(" "),_c('div',{staticClass:"recommend"},[_c('h3',[_vm._v("推荐")]),_vm._v(" "),_c('row-item-list',{attrs:{"list":_vm.recommendList}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a2c011","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Column/search.vue
// module id = null
// module chunks = 